<template>
  <b-row>
    <b-col
      md="12"
      class="d-flex justify-content-end"
    >
      <b-button
        v-b-modal.edit-info-client
        size="sm"
        variant="warning"
      >
        <feather-icon
          icon="EditIcon"
          size="14"
        />
        {{ $t('generals.edit') }}
      </b-button>
    </b-col>
    <b-col md="12">

      <b-row>
        <b-col md="6">
          <b-form-group
            :label="$t('clients.legal_address')"
            label-for="item-name"
          >
            <b-form-input
              id="item-name"
              type="text"
              disabled
              :value="getOneClient.address"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('clients.inn')"
            label-for="item-name"
          >
            <b-form-input
              id="item-name"
              type="text"
              disabled
              :value="getOneClient.inn"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('clients.okved')"
            label-for="item-name"
          >
            <b-form-input
              id="item-name"
              type="text"
              disabled
              :value="getOneClient.oked"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('clients.nds_code')"
            label-for="item-name"
          >
            <b-form-input
              id="item-name"
              type="text"
              disabled
              :value="getOneClient.code_nds"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
    </b-col>

    <b-col
      md="12"
      class="mt-2"
    >
      <div class="d-flex justify-content-end">
        <b-button
          v-b-modal.edit-requisite
          size="sm"
          variant="success"
          @click="editRequisite = null"
        >
          <feather-icon icon="PlusIcon" />
          {{ $t('generals.add') }}
        </b-button>
      </div>
    </b-col>

    <b-col
      v-for="requisite in getOneClient.requisites"
      :key="requisite.account"
      md="6"
      class="mt-1"
    >
      <b-list-group>
        <b-list-group-item class="d-flex flex-column align-items-start">
          <div class="d-flex w-100 justify-content-between">
            <small class="text-secondary">{{ $t('clients.bank') }}:</small>
            <h5 class="mb-1">
              {{ requisite.bank_requisite.bank }}
            </h5>
          </div>
          <div class="d-flex w-100 justify-content-between">
            <small class="text-secondary">{{ $t('clients.bank') }}:</small>
            <h5 class="mb-1">
              {{ requisite.bank_requisite.checking_account }}
            </h5>
          </div>
          <div class="d-flex w-100 justify-content-between">
            <small class="text-secondary">{{ $t('clients.bank_code') }}:</small>
            <h5 class="mb-1">
              {{ requisite.bank_requisite.mfo }}
            </h5>
          </div>
        </b-list-group-item>
        <b-list-group-item class="d-flex flex-column align-items-start">
          <div class="d-flex w-100 justify-content-end">

            <b-button
              v-b-modal.edit-requisite
              size="sm"
              variant="warning"
              @click="editRequisite = requisite"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button
              class="ml-1"
              size="sm"
              variant="danger"
              @click="deleteRequisite(requisite.id)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-col>

    <EditAdditionallyInfoClient />
    <RequisiteModal :requisite="editRequisite" />
  </b-row>

</template>

<script>
import {
  BRow, BCol, BButton, BListGroup, BListGroupItem, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import EditAdditionallyInfoClient from './EditAdditionallyInfoClient.vue'
import RequisiteModal from './RequisiteModal.vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  components: {
    BRow, BCol, BButton, EditAdditionallyInfoClient, RequisiteModal, FeatherIcon, BListGroup, BListGroupItem, BFormGroup, BFormInput,
  },
  data() {
    return {
      editRequisite: null,
    }
  },
  computed: {
    ...mapGetters('clients', ['getOneClient']),
  },
  methods: {
    ...mapActions('clients', ['DELETE_ONE_REQUISITE']),
    async deleteRequisite(id) {
      await this.DELETE_ONE_REQUISITE(id)
      this.$emit('refresh')
    },
  },

}

</script>

<style>

</style>
